import { LockAccessCodeStatus, LockAccessCodeType } from '@core/enums';

export interface LockBridge {
  ragId: string | null;
  ragLoginUser: string | null;
  ragLoginPass: string | null;
  ragMainDeviceId: string | null;
}

export interface LockDevice {
  batteryLevel?: number;
  deviceId: string;
  name?: string;
  status?: DeviceStatus;
  type?: string;
  isMainDevice?: boolean;
  createdAt?: string;
  pairedAt?: string;
  updatedAt?: string;
  rssi?: number;
  unlockDirection?: string;
}

export enum DeviceStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface LockStatus {
  state: LockState;
  error: string;
}
export enum LockState {
  ERROR = 'ERROR',
  CONNECTED = 'CONNECTED',
}

export interface LockAccessCode {
  codeName?: string;
  codeType?: LockAccessCodeType;
  startDate?: string | Date;
  endDate?: string | Date;
  passcode?: string;
  status?: LockAccessCodeStatus;
}

export interface LockAccessCodesResponse {
  codes: LockAccessCode[];
}

export interface LockAccessHistory {
  access: string;
  accessMethod: string;
  status: string;
  statusCode: number;
  activity: string;
  date: string | Date;
  time: string;
}

export interface LockActionResponse {
  success: boolean;
  data: {
    batteryLevel: number | null;
    createdAt: string | null;
    deviceId: string | null;
    name: string | null;
    pairedAt: string | null;
    rssi: number | null;
    type: string | null;
    unlockDirection: string | null;
    updatedAt: string | null;
  } | null;
  error: {
    code: string | null;
    message: string | null;
  } | null;
}

export interface LockBattery {
  deviceId: string;
  batteryLevel: number;
  type: string;
  pairedAt: string;
}

export interface LockCreate {
  deviceId: string;
  name: string;
  rentalId: string;
  type: string;
}

export interface LockUpdate {
  name?: string;
}

export interface LockFilterParams {
  rentalId?: string;
  type?: string;
  searchValue?: string;
  page?: number;
  size?: number;
}

export type LockConnectionState = 'CONNECTED' | 'ERROR';

export interface LockLoginStatus {
  state: LockConnectionState;
  error: string | null;
}
